import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  FormGroup,
} from "reactstrap";

const SubscriptionPlanModal = ({ isOpen, toggle, subscription }) => {
  const _closeModal = () => {
    toggle();
  };

  const _cancelHandler = () => {
    _closeModal();
  };
  // console.log("subscription",subscription);

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => _closeModal()}
      scrollable
      centered
    >
      <ModalHeader toggle={() => _closeModal()}>Subscription Plans</ModalHeader>
      <ModalBody>
        <Table responsive>
          <thead>
            <tr>
              <th>Bill Cycle</th>
              <th>Media</th>
              <th>Pricing</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {subscription?.map((each, index) => (
              <tr key={index}>
                <td>
                  {each?.planType === "Custom"
                    ? each?.customDetails?.count +
                      " " +
                      each?.customDetails?.planType
                    : each?.planType}
                </td>
                <td>
                  <FormGroup>
                    {/* <Input type="switch" role="switch" />
                  <Label check> */}
                    {each?.isMediaIncludes === false
                      ? "Not Included"
                      : "Included"}
                    {/* </Label> */}
                  </FormGroup>
                </td>
                <td>${each?.amount}</td>
                <td>{each?.description ? each?.description : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button
          color="link"
          className="closeBtn"
          onClick={() => _cancelHandler()}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubscriptionPlanModal;
